import {getBaseUrl} from './utils';
import {FooterConfig, GetConfigParams} from '../shared';

const PHONE_NUMBER = '0800 123 642';
const CORPORATE_PHONE_NUMBER = null;
const ABSOLUTE_BASEURL = 'https://www.nib.co.nz';

const getNzConfig = (config: GetConfigParams): FooterConfig => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-nz',
    countryOfOrigin: 'New Zealand',
    columns: [
      {
        id: 'ga-footer-nz-quick-links',
        title: 'Quick links',
        children: [
          {
            id: 'ga-footer-nz-special-offers',
            title: 'Special offers',
            url: `${baseUrl}/special-offers`
          },
          {
            id: 'ga-footer-nz-claiming-on-your-health-cover',
            title: 'Claiming on your health cover',
            url: `${baseUrl}/claims`
          },
          {
            id: 'ga-footer-nz-claim-on-your-life-and-living-insurance',
            title: 'Claim on your life and living insurance',
            url: 'https://health.nib.co.nz/contact-us/life-and-living-claims'
          },
          {
            id: 'ga-footer-nz-claim-on-your-travel-cover',
            title: 'Claim on your travel cover',
            url: 'https://www.nibtravel.co.nz/claims'
          },
          {
            id: 'ga-footer-nz-careers',
            title: 'Careers',
            url: 'https://careers.nib.co.nz/'
          },
          {
            id: 'ga-footer-nz-financial-strength-and-advice',
            title: 'Financial strength and advice',
            url: `${baseUrl}/about-nib/financial-advice/`
          },
          {
            id: 'ga-footer-nz-sitemap',
            title: 'Sitemap',
            url: `${baseUrl}/sitemap`
          }
        ]
      }
    ],
    contact: {
      heading: 'Get in touch',
      contactLinks: [
        {
          id: 'ga-footer-nz-',
          title: 'Contact us',
          url: 'https://health.nib.co.nz/contact-us'
        },
        {
          id: 'ga-footer-nz-give-us-feedback',
          title: 'Give us feedback',
          url: `${baseUrl}/complaints`
        }
      ],
      socialLinks: [
        {
          id: 'ga-footer-nz-facebook',
          key: 'Facebook',
          title: 'Like nib NZ on Facebook',
          url: 'https://www.facebook.com/nibNewZealand'
        },
        {
          id: 'ga-footer-nz-twitter',
          key: 'Twitter',
          title: 'Follow nib NZ on Twitter',
          url: 'https://twitter.com/nibNewZealand'
        },
        {
          id: 'ga-footer-nz-youtube',
          key: 'Youtube',
          title: 'Follow nib NZ on YouTube',
          url: 'https://www.youtube.com/channel/UCBm3fuwAOqunJWBVtkfTvXA/about'
        }
      ]
    },
    smallFooterConfig: {
      id: 'small-footer-nz',
      copyrightText: `Copyright © ${new Date().getFullYear()} nib nz limited, 48 Shortland St, Auckland. All rights reserved.`,
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      links: [
        {
          id: 'ga-footer-nz-terms',
          title: 'Terms & Conditions',
          url: `${baseUrl}/terms-and-conditions`
        },
        {
          id: 'ga-footer-nz-privacy',
          title: 'Privacy Policy',
          url: `${baseUrl}/privacy-policy`
        }
      ]
    }
  };
};

export default getNzConfig;
